module.exports = __webpack_public_path__ + "static/media/Ledian_gaussian2.eea4eb77.png";